import _ from 'lodash'
import { Proving, ResourceSelectionType } from 'model'
import {
  IStackItemStyles,
  IStackTokens,
  Label,
  Stack,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export const ProvingDetailsPlausabilityCheckForm: React.FC<{
  proving: Partial<Proving>
}> = ({ proving }) => {
  const { t } = useTranslation()
  const check = () => {
    const result: any[] = []
    let lowestDateParticipants: any
    let latestDateParticipants: any
    let lowestDateResourceRequirements: any
    let latestDateResourceRequirements: any
    let lowestDate: Date
    let latestDate: Date

    if (
      proving &&
      proving.participants!.length === 0 &&
      proving &&
      proving.resourceRequirements!.length === 0
    ) {
      result.push('Nix is da')
      return result
    }

    if (proving && proving.participants) {
      lowestDateParticipants = _.minBy(proving.participants, (p) => {
        return p.dateFrom
      })
      latestDateParticipants = _.maxBy(proving.participants, (p) => {
        return p.dateTo
      })
    }
    if (proving && proving.resourceRequirements) {
      lowestDateResourceRequirements = _.minBy(
        proving.resourceRequirements,
        (r) => {
          if (r.resourceRequirementType === ResourceSelectionType.Workstation) {
            return r.dateFrom
          }
        }
      )
      latestDateResourceRequirements = _.maxBy(
        proving.resourceRequirements,
        (r) => {
          if (r.resourceRequirementType === ResourceSelectionType.Workstation) {
            return r.dateTo
          }
        }
      )
    }
    // Get earliest Date
    if (lowestDateParticipants && !lowestDateResourceRequirements) {
      lowestDate = new Date(lowestDateParticipants.dateFrom)
    } else if (lowestDateResourceRequirements && !lowestDateParticipants) {
      lowestDate = new Date(lowestDateResourceRequirements.dateFrom)
    } else {
      lowestDateParticipants.dateFrom < lowestDateResourceRequirements.dateFrom
        ? (lowestDate = new Date(lowestDateParticipants.dateFrom))
        : (lowestDate = new Date(lowestDateResourceRequirements.dateFrom))
    }

    // Get latest Date
    if (latestDateParticipants && !latestDateResourceRequirements) {
      latestDate = new Date(latestDateParticipants.dateTo)
    } else if (latestDateResourceRequirements && !latestDateParticipants) {
      latestDate = new Date(latestDateResourceRequirements.dateTo)
    } else {
      latestDateParticipants.dateTo < latestDateResourceRequirements.dateTo
        ? (latestDate = new Date(latestDateResourceRequirements.dateTo))
        : (latestDate = new Date(latestDateParticipants.dateTo))
    }

    const diffTime: any = Math.abs(latestDate.getTime() - lowestDate.getTime())
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    const participantBookings = new Array<number>(diffDays).fill(0)
    const resourceBookings = new Array<number>(diffDays).fill(0)
    const dates = []

    let index = 0
    for (
      lowestDate;
      lowestDate < latestDate;
      lowestDate.setDate(lowestDate.getDate() + 1)
    ) {
      const dateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }
      dates.push(lowestDate.toLocaleDateString('de-DE', dateOptions))
      if (proving && proving.participants) {
        for (
          let participant = 0;
          participant < proving.participants.length;
          participant++
        ) {
          if (
            new Date(proving!.participants![participant].dateFrom) <=
              lowestDate &&
            new Date(proving!.participants![participant].dateTo) >= lowestDate
          ) {
            participantBookings[index] += 1
          }
        }
      }
      if (proving && proving.resourceRequirements) {
        // tslint:disable-next-line: prefer-for-of
        for (
          let resource = 0;
          resource < proving.resourceRequirements.length;
          resource++
        ) {
          if (
            proving.resourceRequirements[resource].resourceRequirementType ===
            ResourceSelectionType.Workstation
          ) {
            if (
              new Date(proving.resourceRequirements[resource].dateFrom) <=
                lowestDate &&
              new Date(proving.resourceRequirements[resource].dateTo) >=
                lowestDate
            ) {
              if (
                proving &&
                proving.resourceRequirements &&
                proving.resourceRequirements[resource].amount
              ) {
                resourceBookings[index] +=
                  proving.resourceRequirements[resource].amount!
              }
            }
          }
        }
      }
      index++
    }
    for (let i = 0; i < participantBookings.length; i++) {
      if (participantBookings[i] < resourceBookings[i]) {
        result.push(
          `${dates[i]}: ${resourceBookings[i]} Büroarbeitsplätze >
            ${participantBookings[i]} Teilnehmeranzahl`
        )
      } else if (participantBookings[i] > resourceBookings[i]) {
        result.push(
          `${dates[i]}: ${resourceBookings[i]} Büroarbeitsplätze < ${participantBookings[i]} Teilnehmeranzahl`
        )
      }
    }
    return result
  }

  const itemAlignmentsStackTokens: IStackTokens = {
    childrenGap: 5,
    padding: 10,
  }

  const stackItemStyles: IStackItemStyles = {
    root: {
      padding: 5,
    },
  }

  const test = check()

  return (
    <>
      <Stack tokens={itemAlignmentsStackTokens} styles={stackItemStyles}>
        {test.length > 0 ? (
          <>
            <Label>{t('panels.plausabilityCheck.check.label')}</Label>
            {check().map((element: string, i) => {
              return <Stack.Item key={i}>{element}</Stack.Item>
            })}
          </>
        ) : (
          <>
            <Label>{t('panels.plausabilityCheck.ok.label')}</Label>
          </>
        )}
      </Stack>
    </>
  )
}
